import React, { useEffect, useState } from "react";
import { AIRTABLE_URL_TECHNICIAN, AIRTABLE_HEADERS } from "./constants";

export default function ViewMyIssues() {
  const [technicianPhone] = useState(localStorage.getItem("technicianPhone") || "");
  const [myIssues, setMyIssues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchIssues = async () => {
      try {
        const res = await fetch(AIRTABLE_URL_TECHNICIAN, {
  headers: AIRTABLE_HEADERS, // ✅ centralized headers
});
        const json = await res.json();
        const records = json.records || [];

        const filtered = records
          .filter((record) => record.fields.technicianPhone?.trim() === technicianPhone.trim())
          .map((record) => record.fields)
          .reverse(); // latest first

        setMyIssues(filtered);
      } catch (err) {
        console.error("❌ Failed to load technician issues:", err);
      } finally {
        setLoading(false);
      }
    };

    if (technicianPhone) {
      fetchIssues();
    } else {
      setLoading(false);
    }
  }, [technicianPhone]);

  return (
    <div style={{ padding: "30px 0", margin: "0" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h2>📋 My Reported Issues</h2>
        <button
          onClick={() => window.location.href = "/technician-home"}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            background: "none",
            border: "none",
            fontSize: 20,
            cursor: "pointer",
            color: "black"
          }}
        >
          ✖
        </button>
      </div>

      {loading ? (
        <p>Loading issues...</p>
      ) : myIssues.length === 0 ? (
        <p>🚫 No issues found for your number.</p>
      ) : (
        myIssues.map((item, idx) => (
          <div
            key={idx}
            style={{
              border: "1px solid #ccc",
              borderRadius: 8,
              padding: 15,
              marginBottom: 15,
              backgroundColor: "#f9f9f9",
            }}
          >
            <p><strong>🆔 Issue ID:</strong> {item.issueId}</p>
            <p><strong>📞 Phone:</strong> {item.technicianPhone}</p>
            <p><strong>📂 Category:</strong> {item.issueCategory}</p>
            <p><strong>📝 Description:</strong> {item.issueDescription}</p>
            <p><strong>🕒 Submitted:</strong> {item.issueDateTime}</p>
            <p><strong>📌 Status:</strong> {item.complaintStatus}</p>
            <p><strong>🗣️ Admin Response:</strong> {item.adminResponse || "Waiting..."}</p>
          </div>
        ))
      )}
    </div>
  );
}
